interface NewsItem {
  id: number;
  title: string;
  content: string;
  created_at?: string;
}

const API_URL = process.env.REACT_APP_API_URL;

/**
 * універсальний fetch з cookie-авторизацією
 */
const fetchWithAuth = async (
  url: string,
  options: RequestInit = {}
) => {
  const res = await fetch(url, {
    ...options,
    credentials: 'include' 
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }

  // деякі DELETE / PATCH можуть нічого не повертати
  if (res.status === 204) return null;

  return res.json();
};

export const adminApi = {
  // ---------- AUTH ----------
  login: (username: string, password: string) =>
    fetchWithAuth(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    }),

  logout: () =>
    fetchWithAuth(`${API_URL}/auth/logout`, {
      method: 'POST'
    }),

  // ---------- REVIEWS ----------
  getReviews: () =>
    fetchWithAuth(`${API_URL}/reviews/admin`),

  approveReview: (id: number) =>
    fetchWithAuth(`${API_URL}/reviews/${id}/approve`, {
      method: 'PATCH'
    }),

  deleteReview: (id: number) =>
    fetchWithAuth(`${API_URL}/reviews/${id}`, {
      method: 'DELETE'
    }),

 answerReview: (id: number, answer: string, isFeedback: boolean) =>
  fetchWithAuth(`${API_URL}/reviews/${id}/answer`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      answer, 
      is_feedback: isFeedback // Передаємо новий статус на бекенд
    })
  }),

// ---------- NEWS ----------
getNews: (): Promise<NewsItem[]> =>
  fetchWithAuth(`${API_URL}/news`),

createNews: (title: string, content: string) =>
  fetchWithAuth(`${API_URL}/news`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title, content })
  }),

// 🟢 Додаємо метод для оновлення новини
updateNews: (id: number, title: string, content: string) =>
  fetchWithAuth(`${API_URL}/news/${id}`, {
    method: 'PUT', // або 'PATCH', залежно від вашого бекенду
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title, content })
  }),

deleteNews: (id: number) =>
  fetchWithAuth(`${API_URL}/news/${id}`, {
    method: 'DELETE'
  }),

  // ---------- SERVICES ----------
  createService: (data: any) =>
    fetchWithAuth(`${API_URL}/services`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }),

  // 🟢 Додаємо цей метод
  updateService: (id: number, data: any) =>
    fetchWithAuth(`${API_URL}/services/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }),

  deleteService: (id: number) =>
    fetchWithAuth(`${API_URL}/services/${id}`, {
      method: 'DELETE'
    }),

  // ---------- GALLERY ----------
  createImage: (data: { image_url: string }) =>
    fetchWithAuth(`${API_URL}/gallery`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }),

  deleteImage: (id: number) =>
    fetchWithAuth(`${API_URL}/gallery/${id}`, {
      method: 'DELETE'
    }),

  // ---------- EMPLOYEES ----------
createEmployee: (data: any) =>
  fetchWithAuth(`${API_URL}/employees`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }),

// 🟢 Додаємо метод для оновлення
updateEmployee: (id: number, data: any) =>
  fetchWithAuth(`${API_URL}/employees/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }),

deleteEmployee: (id: number) =>
  fetchWithAuth(`${API_URL}/employees/${id}`, {
    method: 'DELETE'
  }),

    updateClinic: async (data: { address: string; phone: string; work_schedule: string; map_link: string }) => {
      const response = await fetch(`${API_URL}/clinic/1`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Failed to update clinic info');
      return response.json();
    },

    // Fix all image URLs in the database (admin only)
    fixImageUrls: async () => {
      const response = await fetch(`${API_URL}/admin/fix-image-urls`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to fix image URLs');
      return response.json();
    }
};
